<template>
  <div class="user">
      <h2>user id: {{ $route.params.id }}</h2>

      <h4> Title: {{ user.UserName}} </h4>
    </div>
</template>
<script>

      import * as API from './../../api';

    export default {
        name: "UserDetail",
        methods: {
            getUser() {
               this.$api.get(API.endpoints.users + '/' + this.$route.params.id)
                    .then(response => {
                        this.user = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            title: "Error",
                            message: error,
                            type: 'danger'
                        });
                    });
            },
        },
        data() {
            return {
                user: [ ],
               
            }
        },
        mounted() {
            this.getUser();
        },

    }
</script>